/**
 * API Configuration
 * Dynamically determines the backend URL based on the current environment
 */

/**
 * Get the backend URL based on the current hostname
 * @returns {string} The backend API URL
 */
export const getBackendURL = () => {
  // Get current hostname
  const hostname = window.location.hostname;

  // Check for environment variable first (works for both Vite and CRA)
  const envBackendUrl = import.meta.env?.VITE_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
  
  if (envBackendUrl) {
    return envBackendUrl;
  }

  // If accessing via localhost, use local backend
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }

  // For production/staging on sslip.io
  // Use nginx reverse proxy - return same domain
  // The nginx config will proxy /api/* requests to the backend
  const protocol = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${protocol}//${hostname}${port}`;
};

// Export the backend URL
export const BACKEND_URL = getBackendURL();

// Export the API base URL
export const API_URL = `${BACKEND_URL}/api`;

// Always log the configuration for debugging
console.log('API Configuration:', {
  hostname: window.location.hostname,
  port: window.location.port,
  protocol: window.location.protocol,
  BACKEND_URL,
  API_URL,
  fullContactURL: `${API_URL}/public/contact`
});